<template>
  <v-card class="client opportunity press-links component my-3">
    <v-card-title class="title">In the Press</v-card-title>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12 md6 lg4 v-for="(link,i) in links" :key="i">
          <v-card class="organization press-link card ma-2" flat tile>
            <v-img :src="link.preview" height="240px">
              <v-container fill-height fluid>
                <v-layout column fill-height>
                  <v-flex xs12 align-end flexbox>
                    <span class="caption">{{ link.title }}</span>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-img>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
// Vue Component
export default {
  props: { links: Array }
}
</script>

<style lang="scss">
.client.opportunity.press-links.component {
  .organization.press-link.card {
    min-width: 320px;

    .card__media .caption {
      text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.7);
    }
  }
}
</style>
